








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// tslint:disable-next-line:no-var-requires
const noUiSlider = require('nouislider');

@Component
export default class RangeSlider extends Vue {
  @Prop({ default: 10 }) private max!: number;
  @Prop({ default: 0 }) private min!: number;
  @Prop({ default: 1 }) private start!: number;
  @Prop({ default: 1 }) private step!: number;
  @Prop({ default: false }) private squared!: boolean;

  private sliderUi!: any;

  private mounted() {
    this.initializeSlider();
  }

  @Watch('start')
  private watchStart(newVal: any, oldVal: any) {
    if (newVal !== oldVal) {
      this.sliderUi.noUiSlider.set(newVal);
    }
  }

  @Watch('max')
  private watchMax(newVal: any, oldVal: any) {
    if (newVal !== oldVal) {
      this.sliderUi.noUiSlider.updateOptions(
        {
          range: {
            min: this.min,
            max: this.maxAmount,
          },
        },
        true,
      );
    }
  }

  // TODO averiguar porqué con max 9 hay números que no salen
  get maxAmount() {
    const decimals = '.01';
    let amount = this.max;
    if (this.max === 9 || this.max === 1) {
      amount = Number(`${this.max}${decimals}`);
    }
    return amount;
  }

  private initializeSlider() {
    const slider = this.$refs.slider as HTMLElement;

    noUiSlider.create(slider, {
      start: this.start,
      step: this.step,
      padding: [1, 0],
      tooltips: true,
      format: {
        from: (value: any) => {
          return parseInt(value, 10);
        },
        to: (value: any) => {
          return parseInt(value, 10);
        },
      },
      connect: [true, false],
      range: {
        min: [this.min],
        max: [this.maxAmount],
      },
    });

    this.sliderUi = slider as any;

    this.sliderUi.noUiSlider.on('slide', (values: any, handle: any) => {
      const value = values[0];
      this.$emit('slide', value);
    });

    this.sliderUi.noUiSlider.on('update', (values: any, handle: any) => {
      const value = values[0];
      this.$emit('input', value);
    });
  }
}
